const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let observer;
const seen = new WeakSet();
function observe(root = document) {
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
  observer ??= new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (seen.has(entry.target)) continue;
      seen.add(entry.target);
      if (!reducedMotion.matches && entry.target.animate) entry.target.animate(
        [{ opacity: .65, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 420, easing: 'cubic-bezier(.2,.65,.3,1)' }
      );
    }
  }, { threshold: .08 });
  root.querySelectorAll('[data-vh-reveal]').forEach(element => observer.observe(element));
}
observe();
document.addEventListener('shopify:section:load', event => observe(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-vh-reveal]').forEach(element => observer?.unobserve(element));
});
reducedMotion.addEventListener('change', () => {
  if (reducedMotion.matches) {
    observer?.disconnect();
    document.querySelectorAll('[data-vh-reveal]').forEach(element => element.getAnimations().forEach(animation => animation.cancel()));
  } else observe();
});

